import { Avatar, BalanceText, Text, Tooltip, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { CustomerLayoutProps } from '.';

export const Mobile: React.FC<CustomerLayoutProps> = ({
  backgroundColorBadge,
  balance,
  name,
  suitability,
}) => {
  return (
    <VStack p={Spacing['inline.xxs']} space={Spacing['inline.xxxs']}>
      <HStack alignItems="center" space={Spacing['inline.nano']}>
        <Tooltip label={suitability}>
          <VStack>
            <Avatar
              bgColor={backgroundColorBadge}
              initials={suitability}
              testId="suitability-avatar-mobile"
              textColor="neutral.white"
            />
          </VStack>
        </Tooltip>
        <Text
          variant="semibold"
          fontSize={Typography['fontsize.md']}
          color="neutral.black"
          numberOfLines={1}>
          {name}
        </Text>
      </HStack>
      <VStack space={Spacing['inline.nano']}>
        <HStack alignItems="flex-start" justifyContent="space-between">
          <Text color={'neutral.dark'} fontSize={Typography['fontsize.md']} flex={1}>
            Saldo Disponível
          </Text>
          <Box flex={1}>
            <BalanceText
              balance={balance.available}
              isUpdating={balance.isLoading}
              onUpdateButtonPress={balance.onUpdateButton}
              hasUpdateButton
              textAlign="flex-end"
              positiveBalanceColor="neutral.black"
              negativeBalanceColor="feedback.error.default"
            />
          </Box>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between">
          <Text color={'neutral.dark'} fontSize={Typography['fontsize.md']}>
            Saldo Estimado
          </Text>
          <Box alignItems="flex-end">
            <Text
              fontSize={Typography['fontsize.md']}
              numberOfLines={1}
              {...(balance.estimated.startsWith('-') && { color: 'feedback.error.default' })}>
              {balance.estimated}
            </Text>
            <Text color="neutral.light" fontSize={Typography['fontsize.xs']}>
              Após investimento
            </Text>
          </Box>
        </HStack>
      </VStack>
    </VStack>
  );
};
